import { useReducer, useMemo } from 'react';

import reducer, { defaultState, NotificationStateType } from './reducer';

import {
    displayNotification as displayNotificationAction,
    hideNotification as hideNotificationAction,
} from './actions';

function useNotificationState(): NotificationState {
    const [state, dispatch] = useReducer(reducer, defaultState);
    const actions: NotificationActions = useMemo(
        () => ({
            displayNotification: (): void => dispatch(displayNotificationAction()),
            hideNotification: (): void => dispatch(hideNotificationAction()),
        }),
        [dispatch],
    );
    return useMemo(
        () => ({
            notification: state,
            actions,
        }),
        [state, actions],
    );
}

export default useNotificationState;

export interface NotificationActions {
    displayNotification: () => void;
    hideNotification: () => void;
}

export interface NotificationState {
    notification: NotificationStateType;
    actions: NotificationActions;
}
